var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V3.33324V6.66652V9.99976H14.9997V6.66652V3.33324V0H0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 0.000105858H0V10H14.9997V0.000105858Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V3H15V0Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H0V10H15V7Z",
    fill: "#FF153F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRu);
export default __webpack_public_path__ + "static/media/flag_ru.25a16cc33eb0442f82534fff1d537397.svg";
export { ForwardRef as ReactComponent };